// @ts-nocheck
import { useGLTF, useTexture, Plane, Box, Svg } from '@react-three/drei'
import React, { useRef } from 'react'
import * as THREE from 'three'

const texture1 = `${process.env.PUBLIC_URL}/assets/images/glasses/page3c-frame.png`;
const svg2 = `${process.env.PUBLIC_URL}/assets/images/glasses/page3c-arm.svg`;


export default function Model(props) {
  const group = useRef()
  const bodyTex  = useTexture(texture1)

  return (
    <group ref={group} {...props} dispose={null} scale={.85} position-y={0.1} >

      <Svg src={svg2} scale={.001} position={[-1.4,0.4,-1.82]} rotation={[0, -Math.PI/2, 0]}/>
      <Svg src={svg2} scale={.001} position={[1.4,0.4,-1.82]} rotation={[0, -Math.PI/2, 0]}/>


      <Plane args={[3.315, 0.925]} 
      position={[0,0,0]}
      >
         <meshBasicMaterial  map={bodyTex} side={THREE.DoubleSide} alphaTest={0.1}
         transparent 
         />
      </Plane>
      {/*
      <Plane args={[2.21, 0.52]} 
      position={[-1.38,0.175,-1.03]} 
      rotation={[0, -Math.PI/2, 0]}>
         <meshBasicMaterial transparent map={armTex} side={THREE.DoubleSide} alphaTest={0.1} />
      </Plane>
      <Plane args={[2.21, 0.52]}  
      position={[1.38,0.175,-1.03]} 
      rotation={[0, -Math.PI/2, 0]}>
         <meshBasicMaterial transparent map={armTex} side={THREE.DoubleSide} alphaTest={0.1} />
      </Plane>
  */}

    </group>
  )
}

